// extracted by mini-css-extract-plugin
module.exports = {"dashboardCard":"styles_dashboardCard__YXtyp"};